module.exports = __webpack_public_path__ + "static/media/balsamico-tynnyrit.c1cbe3e6.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./media/photos/balsamico-tynnyrit.jpg
 ** module id = 267
 ** module chunks = 0
 **/